<template>
  <section class="join-section">

    <div class="container">

      <div class="header">

        <h1>
          Nous rejoindre
        </h1>

        <p>
          HayMiutyun grandit grâce aux personnes qui partagent notre vision.
          Rejoignez-nous pour construire ensemble une communauté arménienne
          plus forte, solidaire et connectée.
        </p>

      </div>

     <div class="cards">

  <div class="card">

    <div class="icon community">
      <Globe2 />
    </div>

    <h2>
      Un projet communautaire
    </h2>

    <p>
      Participez à la création d'une plateforme qui rassemble les
      Arméniens autour de l'entraide et du partage.
    </p>

  </div>


  <div class="card">

    <div class="icon project">
      <Rocket />
    </div>

    <h2>
      Des projets ambitieux
    </h2>

    <p>
      Contribuez au développement de nouvelles fonctionnalités,
      événements et initiatives solidaires.
    </p>

  </div>


  <div class="card">

    <div class="icon team">
      <UsersRound />
    </div>

    <h2>
      Une équipe passionnée
    </h2>

    <p>
      Rejoignez une équipe motivée par l'envie d'aider et de créer
      quelque chose d'utile pour notre communauté.
    </p>

  </div>


</div>

      <div class="roles">

        <h2>
          Les profils que nous recherchons
        </h2>

        <div class="role-grid">

  <div class="role">

    <div class="role-icon">
      <Code2 />
    </div>

    <strong>
      Développeurs
    </strong>

    <span>
      Web, mobile, backend
    </span>

  </div>


  <div class="role">

    <div class="role-icon">
      <Palette />
    </div>

    <strong>
      Designers
    </strong>

    <span>
      UI/UX, graphisme
    </span>

  </div>


  <div class="role">

    <div class="role-icon">
      <Megaphone />
    </div>

    <strong>
      Communication
    </strong>

    <span>
      Réseaux sociaux, contenu
    </span>

  </div>


  <div class="role">

    <div class="role-icon">
      <HeartHandshake />
    </div>

    <strong>
      Membres actifs
    </strong>

    <span>
      Organisation, idées, événements
    </span>

  </div>


</div>

      </div>

      <div class="form-card">


        <div class="form-title">

          <h2>
            Envoyez votre candidature
          </h2>

          <p>
            Présentez-vous et expliquez-nous comment vous souhaitez contribuer.
          </p>

        </div>

        <form>

          <div class="row">

            <input
              type="text"
              placeholder="Nom et prénom"
            />

            <input
              type="email"
              placeholder="Adresse email"
            />

          </div>

          <input
            type="text"
            placeholder="Votre domaine (Développement, communication...)"
          />

          <textarea
            rows="5"
            placeholder="Parlez-nous de vous et de votre motivation..."
          ></textarea>

          <button>
            Envoyer ma candidature
          </button>

        </form>

      </div>

    </div>

  </section>
</template>

<script setup>
import {
  Code2,
  Palette,
  Megaphone,
  HeartHandshake,
  Globe2,
  Rocket,
  UsersRound
} from "lucide-vue-next"
</script>

<style scoped>
*{
  box-sizing:border-box
}

.join-section{
  padding:40px 20px;
  background:linear-gradient(180deg,#fff,#f7f8fc);
  overflow:hidden
}

.container{
  max-width:1200px;
  width:100%;
  margin:auto
}

.header{
  text-align:center;
  margin-bottom:50px
}

.header h1{
  font-size:48px;
  margin:0 0 15px;
  font-weight:800;
  background:linear-gradient(90deg,#D90012,#0033A0,#F2A800);
  -webkit-background-clip:text;
  color:transparent
}

.header p{
  max-width:750px;
  margin:auto;
  color:#666;
  font-size:18px;
  line-height:1.8
}

.cards{
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:25px;
  margin-bottom:60px
}

.card{
  background:#fff;
  padding:32px;
  border-radius:25px;
  box-shadow:0 15px 40px rgba(0,0,0,.08);
  transition:.35s;
  border-top:4px solid transparent;
  text-align:center
}

.card:nth-child(1){
  border-color:#D90012
}

.card:nth-child(2){
  border-color:#0033A0
}

.card:nth-child(3){
  border-color:#F2A800
}

.card:hover{
  transform:translateY(-8px);
  box-shadow:0 25px 50px rgba(0,0,0,.12)
}

.icon{
  width:65px;
  height:65px;
  display:flex;
  align-items:center;
  justify-content:center;
  margin:0 auto 20px;
  border-radius:20px;
  color:#fff;
  font-size:28px
}

.community{
  background:linear-gradient(135deg,#D90012,#ff5262)
}

.project{
  background:linear-gradient(135deg,#0033A0,#1769ff)
}

.team{
  background:linear-gradient(135deg,#F2A800,#ffd45a)
}

.card h2{
  font-size:23px;
  margin:0 0 12px
}

.card p{
  color:#666;
  line-height:1.7
}

.roles{
  text-align:center;
  margin-bottom:60px
}

.roles h2{
  font-size:32px;
  margin-bottom:35px
}

.role-grid{
  display:grid;
  grid-template-columns:repeat(4,1fr);
  gap:20px
}

.role{
  background:#fff;
  padding:28px 20px;
  border-radius:22px;
  box-shadow:0 10px 25px rgba(0,0,0,.06);
  border:1px solid #eee;
  transition:.3s;
  text-align:center
}

.role:hover{
  transform:translateY(-6px);
  border-color:#D90012
}

.role-icon{
  width:45px;
  height:45px;
  margin:0 auto 15px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:50%;
  background:#fff1f2;
  color:#D90012;
  font-size:22px;
  font-weight:700
}

.role strong{
  display:block;
  font-size:18px
}

.role span{
  display:block;
  margin-top:10px;
  font-size:14px;
  color:#777
}

.form-card{
  width:100%;
  background:#fff;
  padding:40px;
  border-radius:30px;
  box-shadow:0 20px 50px rgba(0,0,0,.08)
}

.form-title{
  text-align:center;
  margin-bottom:30px
}

.form-title h2{
  font-size:32px;
  margin:0 0 10px
}

.form-title p{
  color:#666
}

form{
  display:flex;
  flex-direction:column;
  gap:18px
}

.row{
  display:grid;
  grid-template-columns:repeat(2,minmax(0,1fr));
  gap:18px
}

input,
textarea{
  width:100%;
  padding:15px 18px;
  border-radius:15px;
  border:1px solid #ddd;
  font-size:16px;
  font-family:inherit;
  outline:none;
  transition:.3s
}

input:focus,
textarea:focus{
  border-color:#D90012;
  box-shadow:0 0 0 3px rgba(217,0,18,.1)
}

textarea{
  resize:none
}

button{
  width:100%;
  padding:16px;
  border:none;
  border-radius:30px;
  cursor:pointer;
  color:#fff;
  font-size:17px;
  font-weight:700;
  background:linear-gradient(135deg,#8b0008,#D90012 45%,#0033A0);
  transition:.3s
}

button:hover{
  transform:translateY(-3px);
  box-shadow:0 10px 25px rgba(217,0,18,.25)
}

@media(max-width:900px){
  .cards{
    grid-template-columns:1fr
  }

  .role-grid{
    grid-template-columns:repeat(2,1fr)
  }

  .row{
    grid-template-columns:1fr
  }

  .header h1{
    font-size:38px
  }
}

@media(max-width:480px){
  .join-section{
    padding:25px 15px
  }

  .header h1{
    font-size:32px
  }

  .header p{
    font-size:16px
  }

  .card{
    padding:22px
  }

  .role-grid{
    grid-template-columns:1fr
  }

  .form-card{
    padding:25px 18px;
    border-radius:22px
  }

  .form-title h2{
    font-size:25px
  }

  input,
  textarea{
    font-size:15px
  }

  button{
    font-size:16px
  }
}
</style>